export default "__VITE_ASSET__02bf0948__"